.body {
    font-weight: normal;
    color: var(--grey);
    font-size: var(--font-big);
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 32px;
}
